var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"to":_vm.to}},[_c('font-awesome-icon',{attrs:{"icon":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }